"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VisuallyHiddenTitle = void 0;
var _mui = require("@ori-ui/mui");
const VisuallyHiddenTitle = exports.VisuallyHiddenTitle = (0, _mui.styled)('h1')({
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: 0,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
});
